import { render, staticRenderFns } from "./workspaceWhitelistDialog.vue?vue&type=template&id=26143f40&scoped=true"
import script from "./workspaceWhitelistDialog.vue?vue&type=script&lang=js"
export * from "./workspaceWhitelistDialog.vue?vue&type=script&lang=js"
import style0 from "./workspaceWhitelistDialog.vue?vue&type=style&index=0&id=26143f40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26143f40",
  null
  
)

export default component.exports